import React from 'react';

import SpeakerIcon from '../../layout/graphics/SpeakerIcon';
import MutedIcon from '../../layout/graphics/MutedIcon';

function VolumeControl({ muted }) {
  return muted ? <MutedIcon /> : <SpeakerIcon />;
}

export default VolumeControl;



// WEBPACK FOOTER //
// ./src/parts/VideoPart/VolumeControl.js